import Tooltip from 'bootstrap/js/dist/tooltip';

document.addEventListener('DOMContentLoaded', () => {
  const triggerVideoAutoPlay = () => {
    const video = document.getElementById('top-development-news-video');
    if (!video) return null; // If there is no video in the DOM, exit this function

    const options = {
      root: null, // Use the viewport as the container
      threshold: 0.5 // Trigger when 50% of the video is visible
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Video is visible -> Start playing
          video.play();
        } else {
          // Video is not visible -> Pause to save resources
          video.pause();
        }
      });
    }, options);

    observer.observe(video);
  };

  // TODO: Remove this tooltip import and initialization once new_trending_topics FF is removed
  const tooltipElements = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  tooltipElements.forEach((element) => new Tooltip(element));

  triggerVideoAutoPlay();
});
